var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-items"},[_c('ItemQty',{attrs:{"quantity":_vm.packageQty,"maxqty":_vm.maxPackageQty,"updating":_vm.updating,"candelete":"false"},on:{"update-qty":_vm.emitPackageQty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }